<template>
    <ul>
        <li v-for="item in list.filter(i => i)" :key="item.id">
            <a @click="onItem(item)" :class="{ active: item.id == $route.params.id }" v-html="item.biaoTi"></a>
            <uCatalogueItem v-if="item.children.length" :list="item.children" :bookName="bookName" />
        </li>
    </ul>
</template>

<script>
export default {
    name: "uCatalogueItem",
    props: {
        bookName: {
            type: String,
            default: ""
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    methods: {
        onItem(item) {
            this.jump(`/bookDetail/${item.bookId}/${item.id}/${this.bookName}`);
        }
    },

}
</script>

<style lang="scss" scoped>
ul {
    padding-left: 15px;
    line-height: 2em;

    a.active {
        font-weight: bold;
        // color: #42b883 !important;
        background: #42b883;
        color: #fff !important;
        padding: 0 8px;
        border-radius: 3px;
    }
}
</style>